import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentTrack: null,
    currentTitle: null,
    currentRoute: null,
  },
  mutations: {
    setCurrentTrack(state, { trackUrl, title, route }) {
      state.currentTrack = trackUrl;
      state.currentTitle = title;
      state.currentRoute = route;
    },
  },
  actions: {
    playTrack({ commit }, payload) {
      commit('setCurrentTrack', payload);
    },
  },
});